import React from 'react'
import styles from './reversetext.module.css'

const ReverseText = ({
  badge,
  heading,
  description,
  reversetextsmallheading,
  reversetextsmallbadge,
  reversetextsmalldescription,
  lowercasebadge,
}) => {
  return (
    <div className={styles.reversetextcontainer}>
      <div className={styles.uppertexts}>
        <span
          className={
            lowercasebadge
              ? `${styles.lowercasebadge}`
              : `${styles.reversetextbadge} ${reversetextsmallbadge}`
          }
        >
          {badge}
        </span>
        <p
          className={`${styles.reversetextheading} ${reversetextsmallheading}`}
        >
          {heading}
        </p>
      </div>
      <p
        className={`${styles.reversetextdescription} ${reversetextsmalldescription}`}
      >
        {description}
      </p>
    </div>
  )
}

export default ReverseText
